<template>
	<div class="past-pools-page">
		<div class="past-pools-page__content">
			<h1 class="past-pools-page--header">Your Past Pools</h1>
			<div class="no-pools" v-if="pastPools.length == 0  && !httpInProgress">
				<p>Any past pools you've participated in will show up here.</p>
			</div>

			<pool class="pool" v-for="pool in pastPools" :name="pool.name" :sport="pool.event" :userIsManager="pool.user_is_manager" :apiPath="pool.api_path" :id="pool.id" :key="pool.id"></pool>
		</div>
	</div>
</template>

<script>
	import { mapMutations, mapGetters } from 'vuex'
	import PoolListItem from '../components/PoolListItem'
	import axios from '@/axios'

	export default {
		components: {
			'pool': PoolListItem
		},
		data() {
			return {
				pastPools: [],

			}
		},
		computed: {
			...mapGetters([
				'httpInProgress'
			])
		},
		methods: {
			...mapMutations([
				'HTTP_IN_PROGRESS',
				'HTTP_FINISHED'
			]),
			getPastPools() {
				return axios.get('past-pools')
			}
		},
		created() {
			this.HTTP_IN_PROGRESS()
			this.getPastPools().then(response => {
				
				this.pastPools = response.data.data
				this.HTTP_FINISHED()
			}).catch(() => {
				this.HTTP_FINISHED()
				
			})
		}
	}
</script>

<style lang="scss">
	@import '../styles/app';
	@import '../styles/views/pastPools';
</style>